import { render, staticRenderFns } from "./MenuItemSMS.vue?vue&type=template&id=3a7ed96f&scoped=true&"
import script from "./MenuItemSMS.vue?vue&type=script&lang=js&"
export * from "./MenuItemSMS.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemSMS.vue?vue&type=style&index=0&id=3a7ed96f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7ed96f",
  null
  
)

export default component.exports